import af from "@/locales/af.json";

export default {
  ...af,
};
